<template>
	<section
		class="border-slate-300 relative flex flex-col border-b"
		:style="{
			backgroundImage: `url('/img/knowledge-base-pattern.png')`,
			backgroundSize: '400px 400px',
			backgroundRepeat: 'repeat'
		}"
	>
		<div class="w-full bg-gradient-to-b from-slate-50/95 to-white/95 px-4 pb-12 pt-4 md:pt-12 lg:px-16">
			<!-- Category Header -->
			<div class="flex flex-col-reverse gap-6 md:flex-row md:items-center md:justify-between">
				<div class="flex items-center gap-4">
					<div>
						<h1 class="text-slate-900 mb-2 text-2xl font-bold md:text-3xl">
							{{ $stringUtil.getLocalText(category?.title) || "~" }}
						</h1>
						<p class="text-slate-600 text-base md:text-lg">
							{{ $stringUtil.getLocalText(category?.content) || "~" }}
						</p>
					</div>
				</div>
				<span
					class="text-slate-900 h-14 w-14 cursor-pointer rounded-full border border-slate-900/50 bg-slate-900/5 backdrop-blur-sm duration-300 hover:border-primary/50 hover:bg-primary/10 hover:text-primary max-md:self-end"
					@click="$backWithFallback($routeUrl.BlogUrl())"
				>
					<Icon name="mdi:arrow-left" class="h-full w-full rounded-full p-[15%]" />
				</span>
			</div>
			<!-- Subcategories (if any) -->
			<div v-if="(subCategories?.length || 0) > 0" class="mt-6 flex flex-wrap gap-3">
				<button
					v-for="sub in subCategories"
					:key="sub.id"
					class="rounded-full border-2 px-4 py-2 text-sm font-medium transition-all"
					:class="
						selected === sub.id
							? 'text-white border-primary bg-primary'
							: 'text-slate-700 border-slate-300 hover:border-primary hover:text-primary'
					"
					@click="() => emit('select', sub)"
				>
					{{ $stringUtil.getLocalText(sub.title) }}
				</button>
				<button
					v-if="selected"
					class="text-slate-700 border-slate-300 rounded-full border-2 px-4 py-2 text-sm font-medium hover:text-red-600 hover:border-red-500"
					@click="() => emit('select', null)"
				>
					{{ $t("clear") }}
				</button>
			</div>
		</div>
		<div class="relative flex items-center">
			<div class="absolute left-4 right-4 mx-auto max-w-2xl">
				<input
					v-model="state.searchText"
					type="text"
					:placeholder="$t('search_articles')"
					class="text-slate-900 border-slate-300 w-full rounded-xl border py-3 pe-4 ps-12 focus:outline-none focus:ring-4 focus:ring-white/30"
					@keyup.enter="search"
				/>
				<svg
					class="text-slate-400 absolute start-4 top-1/2 h-5 w-5 -translate-y-1/2"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
					/>
				</svg>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import type { Category } from "~/models/category"

const app = useNuxtApp()
const route = useRoute()

const emit = defineEmits<{
	select: [Category | null]
}>()

defineProps<{
	category?: Category
	subCategories?: Category[]
	selected?: number | null
}>()

const state = reactive({
	searchText: ""
})

const qSearchText = computed(() => String(route.query.s || ""))

watch(
	qSearchText,
	() => {
		state.searchText = qSearchText.value
	},
	{
		immediate: true
	}
)

const search = () => {
	app.$router.replace({
		query: {
			s: state.searchText || undefined
		}
	})
}
</script>
